// DOM construction helpers. Report labels, memos, and any API-derived text are
// UNTRUSTED input (CLAUDE.md AI-layer rules): everything is set via
// textContent / createTextNode — innerHTML is never used with data.

export type Child = Node | string | null | undefined;

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  children: readonly Child[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [name, value] of Object.entries(attrs)) {
    node.setAttribute(name, value);
  }
  for (const child of children) {
    if (child === null || child === undefined) continue;
    node.append(typeof child === "string" ? document.createTextNode(child) : child);
  }
  return node;
}

export function clear(node: Element | ShadowRoot): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}

/** Numeric table cell; negative amounts get the muted-red class. */
export function numCell(display: string, negative: boolean): HTMLTableCellElement {
  const cell = h("td", { class: negative ? "gvf-num gvf-neg" : "gvf-num" }, [display]);
  return cell;
}
